<template>
  <div class="page_index common-box">
    <banner
      :banner-list="bannerList"
    />
    <div class="about common-box">
      <div class="width1460">
        <div class="box-hd flex">
          <div class="left" style="width: 750px; height: 422px;">
<!--            <img-->
<!--              src="@/assets/image/about02.png"-->
<!--              alt=""-->
<!--            />-->
            <video src="https://static.xayxc.com/admin/pc-video.mp4" controls style="width: 750px;">您的浏览器不支持 video 标签。</video>
          </div>
          <div class="right">
            <div class="common-title">
              关于我们
            </div>
            <div class="con">
              大贤集团从事中医药行业30余年，就像一棵草药一样成长。只要你有草药的种子，只要你脚下有泥、心中有梦，你就能够吸收泥土的养分，让自己成长起来，并且成为悬壶济世新篇章中不可或缺的一部分。 从1992年的渡洲中医诊所起步，大贤集团始终坚持“好医好药好技术”的理念，一步步发展为集中药材种子培育、苗圃栽培，中药材种植采集、收购，中药饮片生产、炮制、批发、零售，中医医院和健康管理中心的大型中医药产业链平台。
            </div>
            <div class="more" @click="goUrl()">
              了解更多
            </div>
          </div>
        </div>
        <div class="box-bd">
          <img
            src="@/assets/image/about01.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="qywh common-box">
      <div class="width1460">
        <div class="common-title">
          企业文化
        </div>
        <img
          src="@/assets/image/qywh1.png"
          alt=""
        />
      </div>
    </div>
    <div class="cymk common-box">
      <div class="width1460 cymk-box">
        <div class="con-box">
          <div
            class="con-item"
            @click="navGo(0)"
          >
            <img
              src="@/assets/image/cymk1.png"
              alt=""
            />
            <div class="box">
              <div class="title">
                中药种植板块
              </div>
              <div class="des">
                陕西鑫宇鹏生态农业有限公司作为大贤集团的中药材种植板块，在陕西、甘肃、贵州、安徽、四川等地致力于中药材中华之技术的创新及当地优势品牌的培育。
              </div>
            </div>
          </div>
          <div
            class="con-item"
            @click="navGo(1)"
          >
            <img
              src="@/assets/image/cymk2.png"
              alt=""
            />
            <div class="box">
              <div class="title">
                中药生产板块
              </div>
              <div class="des">
                公司首创大型室内晾晒场1500平方米，整个晾晒过程符合现代化GMP 管理要求及中药传统炮制工艺，避免了药物蛋白的破坏、有效成分的挥发以及中药药性的改变。
              </div>
            </div>
          </div>
          <div
            class="con-item"
            @click="navGo(2)"
          >
            <img
              src="@/assets/image/cymk3.png"
              alt=""
            />
            <div class="box">
              <div class="title">
                中药批发零售板块
              </div>
              <div class="des">
                陕西文贤医药有限责任公司和新疆德贤堂医药有限责任公司作为大贤集团批发零售板块，以中药材、中药饮片批发、销售、配送为主要业务。
              </div>
            </div>
          </div>
          <div
            class="con-item"
            @click="navGo(3)"
          >
            <img
              src="@/assets/image/cymk4.png"
              alt=""
            />
            <div class="box">
              <div class="title">
                医院管理板块
              </div>
              <div class="des">
                医院在中医医联体专科联盟建设、医院整体托管、民营医院股权合作、中医健康管理中心建设、医院管理咨询服务、医康养中心建设及运营及互联网医院软件研发等方面拥有较强优势。
              </div>
            </div>
          </div>
          <div
            class="con-item"
            @click="navGo(4)"
          >
            <img
              src="@/assets/image/cymk5.png"
              alt=""
            />
            <div class="box">
              <div class="title">
                健康管理板块
              </div>
              <div class="des">
                陕西大贤健康管理中心作为大贤集团的健康管理板块，可提供集健康教育、健康检测、健康评估、健康干预、慢病管理、健康跟踪服务于一体的全面型的健康管理服务。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="qyry common-box">
      <div class="width1460 qyry-box">
        <div class="common-title">
          企业荣誉
        </div>
        <swiper
          ref="qyrySwiper"
          :options="qyryOptions"
        >
          <swiper-slide
            v-for="(item, index) in qyry"
            :key="index"
          >
            <img
              :src="item"
              class="slide-image"
              alt="轮播图"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>


<script>
import banner from "@/components/banner.vue";
export default {
  name: "Home",
  components: {
    banner
  },
  data(){
    return {
      bannerList:[
        require('@/assets/image/banner1.jpg'),
        require('@/assets/image/banner2.jpg'),
      ],
      qyry:[
        require('@/assets/image/qyry1.png'),
        require('@/assets/image/qyry2.png'),
      ],

      qyryOptions:{
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 3000
        }
      }
    }
  },
  methods:{
    navGo(type){

      this.$router.push({
        path:'/industry',
          query:{
            type
          }
      })
    },
   goUrl(){
     this.$router.push({
       path:'/companyProfile',
     })
   }
  }
}
</script>



<style scoped lang="less">

.about{
  background-image: url("~@/assets/image/about-bg.png");
  background-size: cover;
  //height: 806px;
  padding: 60px 0 40px;
  .box-hd{
    //height: 293px;
    .right{
      margin-left: 95px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .title{
        font-size: 26px;
        color: #55131D;
        font-weight: bold;
      }
      .con{
        font-weight: 400;
        font-size: 16px;
        line-height: 2;
        margin: 29px 0;
        color: #515152;
        text-indent:2em
      }
      .more{
        width: 145px;
        height: 42px;
        background: #55131D;
        border-radius: 30px 30px 30px 30px;
        color: #fff;
        line-height: 42px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .box-bd{
    margin-top: 70px;
  }
}
.qywh{
  height: 757px;
  background-image: url("~@/assets/image/qywh.png");
  background-size: cover;
  padding: 86px 0 0;
  img{
    width: 100%;
    height: auto;
    margin-top: 42px;
  }
}
.cymk{
  height: 958px;
  background-image: url("~@/assets/image/cymk.png");
  background-size: cover;
  .cymk-box{
    display: flex;
    justify-content: flex-end;
  }
  .con-box{
    width: 720px;
    padding-top: 50px;
    .con-item{
      padding: 16px 20px 25px 57px;
      border-bottom: 1px dashed #B7B6B2;
      display: flex;
      align-items: center;
      cursor: pointer;
      .box{
        margin-left: 59px;
        .title{
          font-size: 22px;
          font-weight: bold;
        }
        .des{
          color: #515152;
          line-height: 2;
          margin-top: 10px;
        }
      }
    }
  }
}
.qyry{
  height: 836px;
  background-image: url("~@/assets/image/qyrybg.png");
  background-size: cover;
  .qyry-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 1460px;
    overflow: hidden;
    .common-title{
      margin-bottom: 46px;
    }
  }
}

</style>
